import React from "react";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import {
  getAllClientsRequest,
  setFakeData
} from "../../services/admin/actions";
import { getClientRequest } from "../../services/client/actions";
import Colors from "../../constants/Colors";
import fakeDataBNP from "./fakeDataBNP";

const styles = theme => ({
  fake: {
    color: Colors.main,
    fontWeight: "bold"
  }
});

class AdminMenu extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.props.getAllClientsRequest();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = clientId => () => {
    this.props.getClientRequest({ clientId });
    this.setState({ anchorEl: null });
  };

  setFakePres = () => {
    this.props.setFakeData(fakeDataBNP);
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <Button
          aria-owns={anchorEl ? "simple-menu" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          Changer de Client
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem classes={{ root: classes.fake }} onClick={this.setFakePres}>
            BNP pres
          </MenuItem>
          {this.props.clients.map((el, i) => {
            return (
              <MenuItem key={i} onClick={this.handleClose(el._id)}>
                {el.name}
              </MenuItem>
            );
          })}
          <Button
            onClick={() => {
              this.setState({ anchorEl: null });
            }}
          >
            Fermer
          </Button>
          {/* <MenuItem onClick={this.handleClose}>Profile</MenuItem>
          <MenuItem onClick={this.handleClose}>My account</MenuItem>
          <MenuItem onClick={this.handleClose}>Logout</MenuItem> */}
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { clients } = state.admin;
  return {
    clients
  };
};

export default connect(
  mapStateToProps,
  { getAllClientsRequest, getClientRequest, setFakeData }
)(withStyles(styles)(AdminMenu));
